import { useLayoutEffect } from 'react';

export function IntercomProvider() {
    useLayoutEffect(() => {
        window.intercomSettings = {
            app_id: "nm7gmk21",
            hide_default_launcher: true,
        };

        const initIntercom = () => {
            const w = window
            const ic = w.Intercom

            if (typeof ic === "function") {
                ic("reattach_activator")
                ic("update", w.intercomSettings)
            } else {
                const d = document
                const i = function () {
                    i.c(arguments)
                }
                i.q = []
                i.c = function (args) {
                    i.q.push(args)
                }
                w.Intercom = i

                const l = function () {
                    const s = d.createElement("script")
                    s.type = "text/javascript"
                    s.async = true
                    s.src = `https://widget.intercom.io/widget/${w.intercomSettings?.app_id}`

                    const x = d.getElementsByTagName("script")[0]
                    x.parentNode?.insertBefore(s, x)
                }

                l()
            }
        }

        initIntercom()

        // MutationObserver to auto-hide launcher forever
        const observer = new MutationObserver(() => {
            const launcher = document.querySelector('.intercom-launcher');
            if (launcher) launcher.style.display = 'none';
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        return () => {
            if (window.Intercom) {
                window.Intercom('shutdown');
            }
            observer.disconnect();
        }
    }, [])

    return null;
}
